import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { isCombo } from 'state/unified-menu/utils';

import { useProductWizardContext } from '../../product-wizard';
import { ProductWizardStep } from '../../product-wizard/types';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';
import { isCustomization } from '../utils';

export const GoNextCta = () => {
  const { formatMessage } = useIntl();

  const { selectedProduct, pickerSelections, slotsSelections } = useProductWizardContext();
  const { goToNextStep, nextFlowStep, currentFlowStep } = useProductWizardFlow();

  const getButtonLabel = () => {
    let dictionaryKey = null;

    switch (nextFlowStep?.step) {
      case ProductWizardStep.PickerCustomizationSides: {
        dictionaryKey = 'nextSelectYourSide';
        break;
      }
      case ProductWizardStep.PickerCustomizationDrinks: {
        dictionaryKey = 'nextSelectYourDrink';
        break;
      }
      case ProductWizardStep.PickerReview: {
        dictionaryKey = isCombo(selectedProduct) ? 'nextReviewYourMeal' : 'nextReviewYourSelection';
        break;
      }
      default: {
        dictionaryKey = 'nextCustomize';
      }
    }

    return formatMessage({ id: dictionaryKey });
  };

  const isDisabled = () => {
    if (currentFlowStep.step === ProductWizardStep.ProductHome) {
      return !Object.keys(pickerSelections).length;
    }
    if (currentFlowStep.step === ProductWizardStep.PickerSelection) {
      return !Object.keys(pickerSelections).includes(currentFlowStep.pickerAspectKey ?? '');
    }
    if (isCustomization(currentFlowStep.step)) {
      return !!currentFlowStep.slotKey && !slotsSelections[currentFlowStep.slotKey];
    }
    return false;
  };

  return (
    <ActionButton
      testID="product-customization-action-button"
      flex={1}
      onPress={goToNextStep}
      disabled={isDisabled()}
    >
      {getButtonLabel()}
    </ActionButton>
  );
};
